<ng-template #immoModal>
  <div
    id="basicModalBodyImmoAuswahl"
    data-cy="immobilien-auswahl-dialog">
    <div nxModalContent>
      <h3
        nxHeadline="subsection-medium"
        class="nx-margin-bottom-s">
        {{ text?.title }}
      </h3>
      @if (shouldShowImmobilienRadioToggle(immobilieRequestIsInProgress$ | async)) {
        <nx-radio-group
          name="immoKdv"
          id="immoKdv"
          class="padding-top-16"
          (groupValueChange)="immobilieRadioClicked($event)"
          [ngModel]="selectedImmobilieId">
          @if (getValidImmobilien().length > 0) {
            <nxt-fieldset
              appearance="default"
              data-cy="immobilienauswahl-valide-adressen">
              <nxt-fieldset-title>
                <h4 class="immo-header">
                  <span>{{ this.text.validImmobilienLabel }}</span>
                  <info-icon
                    [ariaLabel]="this.text.validImmobilienLabel"
                    [textContent]="this.text.validImmobilienInfo"
                    data-cy="immobilienauswahl-info-icon"></info-icon>
                </h4>
              </nxt-fieldset-title>
              <nxt-fieldset-content>
                @for (immobilie of getValidImmobilien(); track trackByIndexAndId(i, immobilie); let i = $index) {
                  <nx-radio
                    [id]="immobilie.immoId"
                    [value]="immobilie.immoId"
                    class="nx-margin-bottom-s">
                    <span [innerHTML]="immobilie.formattedString | html"></span>
                  </nx-radio>
                }
                @if (text.errorMessage) {
                  <nx-error
                    appearance="text"
                    class="nx-margin-bottom-4m"
                    data-cy="immobilienauswahl-error-message"
                    id="immobilienauswahl-error-message"
                    context="error">
                    <span [innerHTML]="text.errorMessage"></span>
                  </nx-error>
                }
              </nxt-fieldset-content>
            </nxt-fieldset>
          }
        </nx-radio-group>
      }
      @if (shouldShowImmobilienRadioToggle(immobilieRequestIsInProgress$ | async)) {
        <nx-radio-group
          class="padding-top-16"
          (groupValueChange)="neueImmobilieRadioClicked($event)"
          [ngModel]="isAuslandsImmobilie$ | async">
          @if (canSelectNeueImmobilie) {
            <nxt-fieldset
              appearance="default"
              class="nx-margin-top-3m"
              data-cy="immobilienauswahl-neue-adresse">
              <nxt-fieldset-title>
                <h4 class="immo-header">
                  <span>{{ this.text.newImmobilieLabel }}</span>
                  <info-icon
                    [ariaLabel]="this.text.newImmobilieLabel"
                    [textContent]="this.text.newImmobilieInfo"></info-icon>
                </h4>
              </nxt-fieldset-title>
              <nxt-fieldset-content>
                @if (!isAuslandsImmobilieAllowed()) {
                  <nx-radio
                    class="nx-margin-bottom-s"
                    [value]="false">
                    <span data-cy="immobilienauswahl-neue-adresse-radio">
                      {{ text?.auswahlAndereImmobilie }}
                    </span>
                  </nx-radio>
                }
                @if (isAuslandsImmobilieAllowed()) {
                  <div>
                    <nx-radio
                      class="nx-margin-bottom-s"
                      [value]="false">
                      <span data-cy="immobilienauswahl-neue-adresse-radio-inland">
                        {{ text?.auswahlImmobilieInland }}
                      </span>
                    </nx-radio>
                    <nx-radio
                      class="nx-margin-bottom-s"
                      [value]="true">
                      <span data-cy="immobilienauswahl-neue-adresse-radio-ausland">
                        {{ text?.auswahlImmobilieAusland }}
                      </span>
                    </nx-radio>
                  </div>
                }
              </nxt-fieldset-content>
            </nxt-fieldset>
          }
          @if (shouldShowNoImmobilienInfoText(immobilien, immobilieRequestIsInProgress$ | async)) {
            <p
              class="nx-margin-bottom-m"
              data-cy="immobilienauswahl-noimmobilien-info">
              {{ text.noImmobilienInfo }}
            </p>
          }
          @if (getExistentImmobilien().length > 0) {
            <nxt-fieldset
              appearance="default"
              class="nx-margin-top-3m"
              data-cy="immobilienauswahl-vorhandene-adressen">
              <nxt-fieldset-title>
                <h4 class="immo-header">
                  <span>{{ this.text.existantImmobilienLabel }}</span>
                  <info-icon
                    [ariaLabel]="this.text.existantImmobilienLabel"
                    [textContent]="this.text.existantImmobilienInfo"></info-icon>
                </h4>
                <nx-message
                  aria-live="polite"
                  class="has-error nx-margin-bottom-m"
                  data-cy="immobilienauswahl-vorhandene-adresse-warning"
                  id="vorhandene-adresse-warning"
                  context="warning">
                  <span [innerHTML]="text?.existantImmobilieWarning"></span>
                </nx-message>
              </nxt-fieldset-title>
              <nxt-fieldset-content>
                @for (immobilie of getExistentImmobilien(); track trackByIndexAndId(i, immobilie); let i = $index) {
                  <nx-radio
                    [id]="immobilie.immoId"
                    [disabled]="true"
                    [value]="immobilie.immoId"
                    class="nx-margin-bottom-s">
                    {{ immobilie.formattedString }}
                  </nx-radio>
                }
              </nxt-fieldset-content>
            </nxt-fieldset>
          }
          @if (getInvalidImmobilien().length > 0) {
            <nxt-fieldset
              appearance="default"
              class="nx-margin-top-3m"
              data-cy="immobilienauswahl-fehlerhafte-adressen">
              <nxt-fieldset-title>
                <h4 class="immo-header">
                  <span>{{ this.text.invalidImmobilienLabel }}</span>
                  <info-icon
                    [ariaLabel]="this.text.invalidImmobilienLabel"
                    [textContent]="this.text.invalidImmobilienInfo"></info-icon>
                </h4>
                @if (showInvalidImmobilieMessage()) {
                  <nx-message
                    aria-live="polite"
                    class="has-error nx-margin-bottom-m nx-margin-top-s"
                    data-cy="immobilienauswahl-fehlerhafte-adresse-warning"
                    id="fehlerhafte-adresse-warning"
                    context="warning">
                    <span [innerHTML]="text?.invalidImmobilieWarning"></span>
                  </nx-message>
                }
              </nxt-fieldset-title>
              <nxt-fieldset-content>
                @for (immobilie of getInvalidImmobilien(); track trackByIndexAndId(i, immobilie); let i = $index) {
                  <nx-radio
                    [id]="immobilie.immoId"
                    [disabled]="true"
                    [value]="immobilie.immoId"
                    class="nx-margin-bottom-s">
                    {{ immobilie.formattedString }}
                  </nx-radio>
                }
              </nxt-fieldset-content>
            </nxt-fieldset>
          }
        </nx-radio-group>
      }
      @if (immobilieRequestIsInProgress$ | async) {
        <div class="spinner nx-margin-bottom-m">
          <h4 class="u-text-left spinner-text nx-margin-bottom-s">
            {{ text?.spinnerText }}
          </h4>
          <nx-spinner
            size="large"
            data-cy="immobilienauswahl-loading-spinner"></nx-spinner>
        </div>
      }
      @if (
        shouldShowImmobilienErrorMessage(
          immobilien,
          immobilieRequestIsInProgress$ | async,
          immobilieRequestFailed$ | async
        )
      ) {
        <div
          class="noimmo-message nx-margin-bottom-m"
          data-cy="immobilienauswahl-noimmobilien-info">
          {{ text.noImmobilienInfo }}
        </div>
      }
      @if (shouldShowImmobilienAuswahlInfoText(text, immobilieRequestFailed$ | async)) {
        <nx-message
          aria-live="polite"
          class="nx-margin-bottom-4m"
          data-cy="immobilienauswahl-info-message"
          id="immobilienauswahl-info-message"
          context="info">
          <span [innerHTML]="text.infoMessage"></span>
        </nx-message>
      }
      @if (immobilieRequestFailed$ | async) {
        <nx-error
          class="nx-margin-bottom-4m"
          data-cy="immobilienauswahl-request-failed-message">
          <strong>{{ text.requestFailedError }}</strong>
          <br />
          {{ text.requestFailedErrorMessage }}
        </nx-error>
      }
    </div>
    <div nxModalActions>
      <button
        nxModalClose
        class="nx-margin-bottom-0 nx-margin-right-xs"
        type="button"
        nxButton="small secondary">
        {{ text?.abbrechenButton }}
      </button>
      <button
        (click)="uebernehmenClicked()"
        class="nx-margin-bottom-0"
        type="button"
        nxButton="small primary"
        [disabled]="!(selectedImmobilieId?.length > 0) && (isAuslandsImmobilie$ | async) === null">
        {{ text?.weiterButton }}
      </button>
    </div>
  </div>
</ng-template>
